let lastCartCount = 0;

fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    lastCartCount = cart.item_count;
  });

setInterval(function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count > lastCartCount) {
        window.location.href = window.Shopify?.routes?.root + 'cart' || '/cart';
      }
      lastCartCount = cart.item_count;
    });
}, 1000);
